<template>
  <div>
    <h3>{{ userName }}</h3>
      <b-overlay
        :show="!comissionLoaded"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-card title="Montant à recevoir">
        
          <h1>{{ (totalComission - totalPayouts).toLocaleString()  }}€</h1>
          ({{ totalComissionWaiting.toLocaleString() }}€ en attente)
          
          
        </b-card>
      </b-overlay>
       <b-overlay
        :show="!payoutsLoaded"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-card title="Liste des paiements">
          <table class="table" v-if="payouts.length>0">
            <tr>
              <th>Date</th>
              <th>Montant</th>
              <th>Monnaie</th>
              <th>N° transaction</th>
            </tr>
            <tr v-for="(payout, index) in payouts" :key="index">
              <td>
                {{ new Date(payout.created * 1000).toLocaleDateString('fr-FR') }}
              </td>
              <td>
                {{(payout.amount/100).toFixed(2)}}
              </td>
              <td>{{ payout.currency }}</td>
              <td>{{ payout.id }}</td>
            </tr>
          </table>
          <div v-else>
            <b-card-text>
              Aucun paiement pour cet utilisateur.
            </b-card-text>
            </div>
        </b-card>
    </b-overlay>
    <b-overlay
        :show="!promotionsLoaded"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
      <b-card title="Codes promo">
        <table class="table" v-if="promotions.length>0">
          <tr>
            <th>Code</th>
          
            <th>Montant de la comission</th>
            <th>Nombre d'utilisations</th>
          </tr>
          <tr v-for="(promotion, index) in promotions" :key="index">
            <td>{{ promotion.code }}</td>
            
          <td>{{ promotion.amount }}%</td>
            <td>{{ promotion.use_count }}</td>
          </tr>
        </table>
        <div v-else>
          <b-card-text>
            Aucune promo pour cet utilisateur.
          </b-card-text>
          </div>
      </b-card>
    </b-overlay>
    <b-overlay
        :show="!payoutRequestsLoaded"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
    <b-card title="Demande de paiements">
       <table class="table" v-if="payout_requests.length>0">
        <tr>
          <th>Date</th>
          <th>Montant</th>
          <th>Méthode de paiement</th>
        </tr>
        <tr v-for="(payout_request, index) in payout_requests" :key="index">
          <td>
            {{payout_request.created_at}}
          </td>
          <td>
            {{payout_request.amount.toFixed(2)}}€
          </td>
           <td>
            {{payout_request.payout_method}}
          </td>
        </tr>
       </table>
       <div v-else>
         <b-card-text>
           Aucune demande de paiement pour cet utilisateur.
         </b-card-text>
        </div>
    </b-card>
    </b-overlay>
     <b-overlay
        :show="!comissionLoaded"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
      <b-card title="Liste des commandes">
        <table class="table" v-if="comissions.length>0">
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Montant</th>
            <th>Produit</th>
          </tr>
          <tr v-for="(comission, index) in comissions" :key="index">
            <td>
              {{comission.id}}
            </td>
            <td>
              {{comission.date}}
            </td>
            <td>
              {{comission.amount.toFixed(2)}}€
            </td>
            <td>
              {{comission.glass.name}}
            </td>
          </tr>
        </table>
        <div v-else>
          <b-card-text>
            Aucune demande de paiement pour cet utilisateur.
          </b-card-text>
          </div>
      </b-card>
      </b-overlay>
    </div>
</template>

<script>
import {BModal, BButton, VBModal, BOverlay,BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import UserForm from './UserForm.vue'

export default {
  components: { 
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BOverlay,
    UserForm
  },
  data() {
    return {
      user:null,
      loaded:false,
      promotions:[],
      payout_requests:[],
      promotionsLoaded:false,
      payoutsLoaded:false,
      payoutRequestsLoaded:false,
      totalPayouts:0,
      payouts:[],
      comissions:[],
      comissionLoaded:false,
      userName:'',
      totalComission:0,
      totalComissionWaiting:0,
    }
  },
  methods:{
    async getPayoutRequests(){
      let payout_requests=await APIRequest.list_with_request('payout-requests', '?user='+this.$route.params.id+'&limit=1000')
      
      if(payout_requests[0].length)
      {
        this.payout_requests=payout_requests[0]
      }
      this.payoutRequestsLoaded=true
      
    },
    async getPayouts(){
      let user_data=await Auth.get_user_with_id(this.$route.params.id)
      this.userName=user_data.name + ' ' + user_data.surname

      if(user_data.stripe_id)
      {
        this.activePayment=true
        let payouts=await APIRequest.get_payouts_stripe(user_data.stripe_id)

        this.totalPayouts=0
        this.payouts=payouts.data
        for(let i=0;i<payouts.data.length;i++)
        {
          this.totalPayouts=this.totalPayouts+payouts.data[i].amount/100
        }

        this.payoutsLoaded=true
        
        //this.totalComission=scans.total
       
        //await this.filterComissionsByDate()
      }
      else 
      {
        this.payoutsLoaded=true
      }
      let scans=await APIRequest.get_comissions(this.$route.params.id)
      this.comissions=scans.data
      this.calculateRealCom()
      this.comissionLoaded=true

      
    },
    calculateRealCom()
    {
      let totalCom=0
      let totalComWaiting=0
      for(let i=0;i<this.comissions.length;i++)
      {
        if(this.comissions[i].date)
        {
          let currentDate = new Date();

          // Add 7 days to the current date
          let beforeDate = new Date(currentDate);
          beforeDate.setDate(currentDate.getDate() - 14);

     
          let [day, month, year] = this.comissions[i].date.split('/'); // Split the date string
          let timestamp = new Date(`${year}-${month}-${day}`); // Convert to timestamp
       
          if(timestamp.getTime()<beforeDate.getTime())
          {
            totalCom+=this.comissions[i].amount
          }
          else
          {
            totalComWaiting+=this.comissions[i].amount
          }

        }
        else 
        {
          totalCom+=this.comissions[i].amount
        }
        
      }
      this.totalComission=totalCom
      this.totalComissionWaiting=totalComWaiting
    },
    async getPromotions()
    {
      let promotions=await APIRequest.list_with_request('promotions','?user='+this.$route.params.id)
      this.promotions=promotions[0]
      this.promotionsLoaded=true
    }
  },
  async mounted()
  {
      
    this.user=await Auth.get_user_with_id(this.$route.params.id)
    await this.getPayouts()
    await this.getPromotions()
    await this.getPayoutRequests()
    this.loaded=true
  }
}
</script>
